import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from "@angular/core";
import { BaseControl, ConfirmComponent, Static } from "@app/shared";
import { LocalDataSource } from "ng2-smart-table";
import { DocumentFormComponentConfig } from "./shared/document-form-component.config.service";
import { Documental, DocumentFormDataService, Documentos_Fomrulario, Funciones } from "./shared/document-form-component.data.service";
import { DocumentFormsService } from "./shared/document-form-component.forms.service";

@Component({
  selector: "iw-document-form",
  templateUrl: "./document-form.component.html",
  styleUrls: ["./document-form.component.scss"],
  providers: [DocumentFormsService, DocumentFormDataService],
})
export class DocumentFormComponent implements OnInit {
  // Configuracion de la tabla
  settings = {};
  // Configuración de la tabla de funciones de radicados
  settingsFunctions = {};
  // Datos para llenar la tabla
  sourceData: LocalDataSource;
  // Datos para llenar la tabla de funciones de radicados
  sourceFunctions: LocalDataSource;
  //Define qué pestaña mostrar
  formFunction: boolean = false;
  // Define si muestra la pestaña de agregar y modificar funcion
  structureEdit: boolean = false;
  // Referencia a la función seleccionada para modificar
  selectedFunction: any = {};
  // Contiene la pregunta de eliminación
  question = "";
  //Datos para llenar la tabla
  table: any[] = [];
  // Series disponibles
  series: any[] = [];
  // Estructura de radicado seleccionada para eliminar
  selectedRadicade: any = {};
  // Subseries disponibles
  subseries: any[] = [];
  // Tipos documentales disponibles
  typeDocumentary: Documental[] = [];
  // Lista de tipos documentales
  typeDocumentaryList: any[] = [];
  //id del tipo documental seleccionado para modificar funciones, eliminar o asociar
  idTypeDocumentary: number = 0;
  // variable que almacena el row seleccionado
  row: any = null;
  //Funciones a agregar al tipo documental
  functions: Funciones[] = [];
  // Lista de documentos de formulario para la forma dinamica
  documentos_formulario: Documentos_Fomrulario[] = [];
  // Contiene los controles de el formulario de funciones
  controls: BaseControl<any>[] = [];
  // Contiene el control de máximo de documentos a interactuar
  control: BaseControl<any>[] = [];
  //Documentos del formulario 
  @Input() documentos_form: Documentos_Fomrulario[];
  // Emite el nombre de la pestaña
  @Output() windowName: EventEmitter<any> = new EventEmitter();
  // emite el número máximo de documentos a interactuar
  @Output() maxDocs: EventEmitter<any> = new EventEmitter();
  //Emite los documentos del formulario
  @Output() document_form: EventEmitter<Documentos_Fomrulario[]> = new EventEmitter<Documentos_Fomrulario[]>();
  // Referencia a la plantilla para el control personalizado de ng-select
  @ViewChild("ngSelect") ngSelectTpl: TemplateRef<any>;
  // Referencia al componente de confirmación
  @ViewChild("confirm") private confirm: ConfirmComponent;
  tableFunction: any[] = [];
  //Manejador de la lista de funciones
  list = [{id: 1, funcion: "Subir"}, {id: 2, funcion: "Radicar"}, {id: 3, funcion: "Asociar"}];
  // Lista por defecto de funciones
  listOptions: any[] = [];
  documentsPushModify: any[] = []
  functionsPush: any[] = [];
  functionsModifyDelete: any[] = [];
  modificar = false;

  constructor(private dfcs: DocumentFormsService, private dfds: DocumentFormDataService) {}

  ngOnInit() {
    this.control = this.getMaxDocuInteractionsControl();
    const configTable = new DocumentFormComponentConfig();
    this.settings = configTable.settings;
    configTable.accion.subscribe((res: any) => {
      this.defineActionFunction(res.action, res.row);
    });
    this.settingsFunctions = configTable.settingsFunctions;
    configTable.accionFuncion.subscribe((res: any) => {
      this.defineActionFunction(res.action, res.data);
    });
    this.getTypeDocumentary();
    this.getFunction()
    this.sourceFunctions = new LocalDataSource(this.tableFunction);
  }

  /**
   *Obtiene el control de máximo de documentos a interactuar
   *
   * @memberof DocumentFormComponent
   */
  getMaxDocuInteractionsControl(objectModel?: any): BaseControl<any>[] {
    return objectModel ? this.dfcs.getMaxDocFunctions(objectModel) : this.dfcs.getMaxDocFunctions();
  }

  /**
   *Obtiene la lista de opciones disponible
   *
   * @memberof DocumentFormComponent
   */
  getFunction(){
    this.dfds.getFunctions().subscribe(async res=>{
      if(res){
        this.listOptions = await res;
      }
    })
  }

  /**
   * Obtener un tipo documental
   *
   * @memberof DocumentFormComponent
   */
  getTypeDocumentary() {
    this.dfds.getTypeDocumentary().subscribe(async (typeDocumentary) => {
      this.typeDocumentary = await typeDocumentary;
      this.typeDocumentary.forEach((item) => {
        this.series.push(item.subserie.serie.nombre);
        this.subseries.push(item.subserie.nombre);
        this.typeDocumentaryList.push(item.nombre);
      });
      this.fillTableModal();
    });
  }

  /**
   *Llena la tabla con los tipos documentales, series y subseries
   *
   * @memberof DocumentFormComponent
   */
  fillTableModal() {
    if(this.documentos_form && this.documentos_form.length){
      let exist: boolean;
      let data = {};
      this.typeDocumentary.forEach((item) => {
        exist = false;
        this.documentos_form.forEach(df=>{
          if(df.tipo_documental == item.id){
            exist = true;
          }
        })
        if(exist){
          data = {
            serie_id: item.subserie.serie.id,
            serie: item.subserie.serie.nombre,
            subserie_id: item.subserie.id,
            subserie: item.subserie.nombre,
            tipo_documental_id: item.id,
            tipo_documental: item.nombre,
            detail: true,
            associate: 'Sí',
          };
        }else{
          data = {
            serie_id: item.subserie.serie.id,
            serie: item.subserie.serie.nombre,
            subserie_id: item.subserie.id,
            subserie: item.subserie.nombre,
            tipo_documental_id: item.id,
            tipo_documental: item.nombre,
            detail: true,
            associate: 'No'
          };
        }
        this.documentos_form.forEach(doc=>{
          if(doc.tipo_documental == item.id){
            exist = true;
            data['documento_forma_id'] = doc.id
          }
        })
        this.table.push(data);
      });
    }else{
      this.typeDocumentary.forEach((item) => {
        let data = {
          serie_id: item.subserie.serie.id,
          serie: item.subserie.serie.nombre,
          subserie_id: item.subserie.id,
          subserie: item.subserie.nombre,
          tipo_documental_id: item.id,
          tipo_documental: item.nombre,
          detail: true,
        };
        data['associate'] = 'No'
        this.table.push(data);
      });
    }
    this.sourceData = new LocalDataSource(this.table);
  }

  /**
   * Define la accion a realizar
   *
   * @param {('add' | 'update' | 'delete')} [action='add']
   * @memberof DocumentFormComponent
   */
  defineActionFunction(action: "asociar" | "eliminar" | "add" | "delete" | "update" | "funciones" = "add", data?: any) {
    let list: any[] = [];
    this.listOptions.forEach(l=>{
      if(l.nombre == 'Subir' || l.nombre == 'Radicar' || l.nombre == 'Generar' || l.nombre == 'Descargar' || l.nombre == 'insertar_sticker'){
        list.push({
          id: l.id,
          funcion: l.nombre
        })
      }
    })
    this.list = Static.copyObjet(list);
    switch (action) {
      case "asociar":
        this.table.forEach(d=>{
          if(d.tipo_documental_id == data.tipo_documental_id){
            d['associate'] = 'Sí'
          }
        })
        let associate = {
          serie: data.serie_id,
          serie_nombre: data.serie,
          subserie: data.subserie_id,
          subserie_nombre: data.subserie,
          tipo_documental_nombre: data.tipo_documental,
          tipo_documental: data.tipo_documental_id,
          funciones: [{}]
        }
        associate.funciones.length = 0;
        this.documentos_form.push(associate)
        this.sourceData.refresh();
        break;
      case "eliminar":
        this.selectedRadicade = data;
        this.selectedFunction = null;
        this.question = "¿Realmente desea desasociar el documento?";
        this.confirm.open();
        break;
      case "funciones":
        this.formFunction = true;
        this.idTypeDocumentary = data.tipo_documental_id;
        data.documento_forma_id ? this.row = data.documento_forma_id : null;
        this.fillTableFunction();
        this.sourceFunctions.refresh();
        this.windowName.emit("Funciones de radicado");
        break;
      case "add":
        this.selectedFunction = null;
        this.tableFunction.forEach((element) => {
          this.list.forEach((list, i) => {
            if (element.funcion == list.id) {
              this.list.splice(i, 1);
            }
          });
        });
        this.structureEdit = true;
        this.controls = this.getControlsFormBasic({
          dataTypeahead: [],
          ngSelectTpl: this.ngSelectTpl,
        });
        this.windowName.emit("Agregar funciones de radicado");
        break;
      case "delete":
        let exist = false;
        this.list.forEach(item=>{
          if(item.id == data.funcion){
            exist = true;
          }
        })
        if(!exist){
          let func = {id: 0, funcion: ''}
          this.listOptions.forEach(opt=>{
            if(opt.id == data.funcion){
              func['id'] = opt.id;
              func['funcion'] = opt.funcion
            }
          });
          this.list.push(func)
        }
        this.selectedFunction = data;
        this.question = "¿Realmente desea eliminar la función?";
        this.confirm.open();
        break;
      case "update":
        this.selectedFunction = data;
        this.tableFunction.forEach((element) => {
          this.list.forEach((list, i) => {
            if (element.funcion == list.id && (this.selectedFunction.funcion !== list.id)) {
              this.list.splice(i, 1);
            }
          });
        });
        this.controls = this.getControlsFormBasic({
          dataTypeahead: [],
          ngSelectTpl: this.ngSelectTpl,
          data,
        });
        this.structureEdit = true;
        break;
    }
  }

  /**
   *Llena la tabla de funciones por tipo documental
   *
   * @memberof DocumentFormComponent
   */
  fillTableFunction(){
    this.documentos_form.forEach(doc=>{
      if(doc.tipo_documental == this.idTypeDocumentary){
        doc.funciones.forEach(d=>{
          this.tableFunction.push(d);
        })
      }
    })
  }

  /**
   *Cierra la pestaña de funciones de radicado
   *
   * @memberof DocumentFormComponent
   */
  closeForm() {
    this.formFunction = false;
    this.structureEdit = false;
    this.tableFunction.length = 0;
    this.sourceFunctions.refresh();
    this.windowName.emit("Estructura de radicado");
    this.idTypeDocumentary = null;
    this.document_form.emit(this.documentsPushModify);
  }

  /**
   * Retorna los controles del formulario.
   *
   * @param {*} [objectModel]
   * @returns {BaseControl<any>[]}
   * @memberof DocumentFormComponent
   */
  getControlsFormBasic(objectModel?: any): BaseControl<any>[] {
    return objectModel ? this.dfcs.getFormFunctions(objectModel) : this.dfcs.getFormFunctions();
  }

  /**
   *Cierra la pestaña de agregar o editar funciones de radicado
   *
   * @memberof DocumentFormComponent
   */
  closeStructureEdit() {
    this.structureEdit = false;
    this.formFunction = true;
    this.windowName.emit("Funciones de radicado");
  }

  /**
   * Guarda o edita un tipo de documental en el sistema
   *
   * @param {*} data
   * @memberof DocumentFormComponent
   */
  async sended(data: any) {
    if (data.maxDocs) {
      this.maxDocs.emit(data.maxDocs)
    } else {
      if(this.selectedFunction){
        // Modificar una función del tipo documental
        let indexDoc = 0;
        let required = 'No';
        if(data.required){
          required = 'Sí';
        } 
        this.documentos_form.forEach((doc, i)=>{
          if(doc.tipo_documental == this.idTypeDocumentary){
            doc.funciones.forEach((d, j)=>{
              if(d.funcion == this.selectedFunction.funcion){
                d.funcion = data.ngSelect;
                indexDoc = i;
                d.id = data.ngSelect;
                d.requerido = data.required;
                this.modificar = true;
              }
            })
          }
        })
        this.list.forEach(l=>{
          if(l.id == data.ngSelect){
            let required = 'No';
            if(data.required){
              required = 'Sí'
            }
            let addFunction = {
              funcion: data.ngSelect,
              funcion_nombre: l.funcion,
              requerido: data.required
            }
            let index = this.tableFunction.indexOf(this.selectedFunction)
            this.tableFunction.splice(index, 1, addFunction);
          }
        });
        if(this.modificar){
          this.documentos_form[indexDoc]['accion'] = 'modificar';
          this.modificar = false;
        }
        // fin actualizar la tabla
      }else{
        // Agregar la nueva función
        let index = 0;
        let nombre = '';
        this.list.forEach(l =>{
          if(l.id == data.ngSelect){
            nombre = l.funcion;
          }
        })
        let addFunction = {
          id: data.ngSelect,
          funcion: data.ngSelect,
          requerido: data.required,
          funcion_nombre: nombre
        };
        this.documentos_form.forEach((doc, i)=>{
          if(doc.tipo_documental == this.idTypeDocumentary){
            this.modificar = true;
            index = i;
            doc.funciones.push(addFunction);
          }
        })
        // fin agregar
        //Actualizar la tabla de funciones
        this.list.forEach(l=>{
          if(l.id == data.ngSelect){
            let required = 'No';
            if(data.required){
              required = 'Sí'
            }
            let addFunction = {
              funcion: data.ngSelect,
              funcion_nombre: l.funcion,
              requerido: data.required
            }
            this.tableFunction.push(addFunction);
          }
        });
        if(this.modificar){
          this.documentos_form[index]['accion'] = 'modificar';
          this.modificar = false;
        }
        // fin de actualizar la tabla
      }
      this.selectedFunction = null;
      this.closeStructureEdit();
      // this.fillTableFunction();
      this.sourceFunctions.refresh();
    }
  }

  /**
   *Elimina la función seleccionada
   *
   * @param {boolean} res
   * @memberof DocumentFormComponent
   */
  actionComfirm(res: boolean) {
    if (res && this.selectedFunction) {
      // eliminar la funcion seleccionada
      let indexFuncion = 0;
      let indexDoc = 0;
      this.documentos_form.forEach((doc, j)=>{
        if(doc.tipo_documental == this.idTypeDocumentary){
          doc.funciones.forEach((d, i)=>{
            if(d.funcion == this.selectedFunction.funcion){
              indexFuncion = i;
              indexDoc = j;
              this.modificar = true;
            }
          })
        }
      })
      this.documentos_form[indexDoc].funciones.splice(indexFuncion, 1);
      //fin de eliminar
      // Actualizar tabla
      let index = this.tableFunction.indexOf(this.selectedFunction);
      this.tableFunction.splice(index, 1);
      //fin de actualizar la tabla
      if(this.modificar){
        this.documentos_form[indexDoc]['accion'] = 'modificar';
        this.modificar = false;
      }
      this.sourceFunctions.refresh();
      this.selectedFunction = null;
    } else if (res && this.selectedRadicade) {
      let index = this.table.indexOf(this.selectedRadicade);
      let indexDoc = 0;
      this.documentos_form.forEach((doc, i)=>{
        if(doc.tipo_documental == this.idTypeDocumentary){
          indexDoc = i;
        }
      });
      this.table[index]['associate'] = 'No';
      this.documentos_form[indexDoc]['accion'] = 'eliminar';
      this.documentos_form[indexDoc].funciones.length = 0;
      this.documentos_form.splice(indexDoc, 1);
      this.sourceData.refresh();
      this.selectedRadicade = null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/creation-dynamic-component/document-form/document-form.component.ts